(function (globalScope) {
  const DISALLOWED_ENGRAVING_CHARACTERS_PATTERN = /[^\p{Script=Latin}0-9 .-]+/gu;

  function buildResponsiveEngravingMetrics(containerWidth) {
    const safeWidth = Number.isFinite(containerWidth) && containerWidth > 0 ? containerWidth : 360;
    const fontSize = Math.max(22, Math.min(34, Math.round(safeWidth * 0.08)));
    const proportionalMaxWidth = Math.round(safeWidth * 0.52);
    const fontBoundMaxWidth = Math.round(fontSize * 6.4);
    const maxWidth = Math.min(proportionalMaxWidth, fontBoundMaxWidth);
    const letterSpacing = Number((fontSize * 0.05).toFixed(2));

    return {
      fontSize,
      maxWidth,
      letterSpacing,
    };
  }

  function sanitizeEngravingInput({ value, maxLength = Infinity }) {
    const safeValue = typeof value === 'string' ? value : '';
    const valueWithoutInvalidCharacters = safeValue.replace(DISALLOWED_ENGRAVING_CHARACTERS_PATTERN, '');
    const safeMaxLength = Number.isFinite(maxLength) && maxLength >= 0 ? maxLength : Infinity;
    const sanitizedValue = Array.from(valueWithoutInvalidCharacters).slice(0, safeMaxLength).join('');

    return {
      sanitizedValue,
      hadInvalidCharacters: valueWithoutInvalidCharacters !== safeValue,
      wasTrimmedToMaxLength: sanitizedValue !== valueWithoutInvalidCharacters,
    };
  }

  function getMeasuredTextWidth({ value, measureTextWidth, letterSpacing = 0 }) {
    const safeValue = value || '';
    const measuredWidth = measureTextWidth(safeValue);
    const spacingWidth = getVisualReserveWidth({
      value: safeValue,
      measuredWidth,
      letterSpacing,
    });

    return measuredWidth + spacingWidth;
  }

  function getVisualReserveWidth({ value, measuredWidth, letterSpacing = 0 }) {
    if (!value || value.length < 2 || !letterSpacing) {
      return 0;
    }

    const averageGlyphWidth = measuredWidth / value.length;
    const wideGlyphThreshold = letterSpacing * 11;
    const reserveProgress = Math.max(0, Math.min(1, (averageGlyphWidth - wideGlyphThreshold) / letterSpacing));
    const maxReserveWidth = Math.max(0, value.length - 1) * letterSpacing;

    return maxReserveWidth * reserveProgress;
  }

  function getWidthValidationState({ previousValue, nextValue, maxWidth, measureTextWidth, letterSpacing = 0 }) {
    const measuredWidth = getMeasuredTextWidth({ value: nextValue, measureTextWidth, letterSpacing });
    const fits = measuredWidth <= maxWidth;

    return {
      acceptedValue: fits ? nextValue : getFittedValue({ value: previousValue, maxWidth, measureTextWidth, letterSpacing }),
      fits,
      measuredWidth,
    };
  }

  function getFittedValue({ value, maxWidth, measureTextWidth, letterSpacing = 0 }) {
    let fittedValue = value || '';

    while (fittedValue && getMeasuredTextWidth({ value: fittedValue, measureTextWidth, letterSpacing }) > maxWidth) {
      fittedValue = fittedValue.slice(0, -1);
    }

    return fittedValue;
  }

  function createCanvasTextWidthMeasurer({ fontFamily = '"Times New Roman", serif', fontWeight = '400', fontSize }) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    return (value) => {
      if (!context) {
        return value.length * fontSize;
      }

      context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
      return context.measureText(value).width;
    };
  }

  const api = {
    buildResponsiveEngravingMetrics,
    sanitizeEngravingInput,
    getMeasuredTextWidth,
    getWidthValidationState,
    getFittedValue,
    createCanvasTextWidthMeasurer,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  globalScope.BelvansEngravingTextFit = api;
})(typeof window !== 'undefined' ? window : globalThis);
